var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfflineDelete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7719 11.9573C14.3368 11.56 14.7605 10.9931 14.9814 10.3387C15.2023 9.68431 15.2089 8.97658 15.0003 8.31819C14.7917 7.65979 14.3787 7.085 13.8213 6.67722C13.2639 6.26944 12.591 6.04989 11.9004 6.05043H11.0816C10.8862 5.28876 10.5205 4.58135 10.0121 3.98146C9.5037 3.38157 8.86584 2.90483 8.14653 2.58713C7.42722 2.26943 6.64521 2.11905 5.85938 2.14731C5.07354 2.17557 4.30435 2.38173 3.60972 2.75028C2.91509 3.11883 2.31312 3.64016 1.84913 4.27502C1.38513 4.90988 1.07121 5.64173 0.930981 6.41547C0.790756 7.18921 0.827886 7.98468 1.03958 8.74199C1.25127 9.49931 1.632 10.1987 2.15312 10.7876",
    stroke: "#97A6A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5455 8.90189L5.67188 13.7755",
    stroke: "#97A6A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67188 8.90189L10.5455 13.7755",
    stroke: "#97A6A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineDelete);
export default __webpack_public_path__ + "static/media/offlineDelete.938fa40054bb4ccae31fd9023be01642.svg";
export { ForwardRef as ReactComponent };